import { useQuery } from '@apollo/client/react';
import { makeStyles } from 'tss-react/mui';
import Divider from '@mui/material/Divider';
import Loading from '../loading';
import ErrorMessage from '../error-message';
import { eventCommentsQuery } from '../../apollo/events';
import Comment from './comment';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  listItem: {
    margin: theme.spacing(0, 0, 1, 0),
  },
}));

type Props = {
  event?: Event;
};

const EventCommentList = ({ event: eventProp }: Props) => {
  const { classes } = useStyles();
  const { data, loading, error } = useQuery(eventCommentsQuery, {
    variables: {
      eventId: eventProp.id
    }
  });
  const event = data?.event;

  if (error) { return <ErrorMessage message='Error loading comments.' compact />; }
  if (loading) { return <Loading compact />; }
  if (!event) { return null; }

  if (!event.comments || !event.comments.length) {
    return null;
  }

  return (
    <ul className={classes.list}>
      {event.comments.map((comment, index) => (
        <li key={comment.id} className={classes.listItem}>
          {index > 0 && <Divider sx={{ mb: 2 }} />}
          <Comment comment={comment} event={event} />
        </li>
      ))}
    </ul>
  );
};

export default EventCommentList;
